import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'

const ReCaptcha = ({
  captchaRef,
  BOTGoogleReCaptchaSiteKey,
  reCaptchaOnChange,
  notVerifiedReCaptchaMessage,
  reCaptchaOnExpired
}) =>
  <>
    <GoogleReCaptcha
      ref={ captchaRef }
      sitekey={ BOTGoogleReCaptchaSiteKey }
      badge="bottomleft"
      onExpired={ reCaptchaOnExpired }
      onChange={ reCaptchaOnChange } />

    {notVerifiedReCaptchaMessage && (
      <ReCaptchaMessage>{notVerifiedReCaptchaMessage}</ReCaptchaMessage>
    )}
  </>

ReCaptcha.propTypes = {
  BOTGoogleReCaptchaSiteKey: PropTypes.string,
  captchaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Component) })
  ]),
  notVerifiedReCaptchaMessage: PropTypes.string,
  reCaptchaOnChange: PropTypes.func,
  reCaptchaOnExpired: PropTypes.func
}

export default ReCaptcha

const GoogleReCaptcha = styled(ReCAPTCHA)`
  margin-bottom: 25px;
`

const ReCaptchaMessage = styled.p`
  color: ${Theme.colors.red};
`
